import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const truncatedText = {
  ...shorthands.overflow('hidden'),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const textButton = {
  display: 'grid',
  ...shorthands.border('none'),
  backgroundColor: 'transparent',
  ...shorthands.padding('0'),
  ...shorthands.margin('0'),
  ...shorthands.overflow('hidden'),
  ...shorthands.borderWidth('0'),
  cursor: 'pointer',
  color: tokens.colorBrandForegroundLink,
};

export const useScopeBarStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '56px',
    backgroundColor: tokens.colorNeutralBackground4,
    ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding('6px', '16px'),
  },
  scopeBarLeft: {
    display: 'flex',
    ...shorthands.overflow('hidden'),

    '& .scope-bar-back-button': {
      color: tokens.colorBrandBackground,
    },
  },
  trailItem: {
    fontWeight: tokens.fontWeightRegular,
    display: 'flex',
    ...shorthands.overflow('hidden'),
    fontSize: '16px',
  },
  trailItemText: {
    whiteSpace: 'nowrap',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
  },
  trailItemSeparator: {
    ...shorthands.margin('0', '8px'),
    fontWeight: tokens.fontWeightSemibold,
  },
  activeTrailItem: {
    fontWeight: tokens.fontWeightSemibold,
  },
  dropdownMenuIcon: {
    fontSize: '16px',
    color: tokens.colorNeutralForeground1,
  },
});

export const useScopeSelectorStyles = makeStyles({
  root: {
    '& .fui-MenuGroupHeader': {
      ...shorthands.padding('0', '4px'),
    },

    '& .scope-filters': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
  },
  menuItem: {
    backgroundColor: 'transparent',
    color: tokens.colorNeutralForeground1,
    maxWidth: 'none',
    flexBasis: 'fit-content',
    flexShrink: 0,
    flexGrow: 1,
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalXS),
    ...shorthands.margin(tokens.strokeWidthThick),
  },
  hover: {
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground3Hover,
    },
  },
  scopeButton: {
    height: '28px',
  },
  listMenuGroup: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: '0',
  },
  customMenuSplitGroup: {
    display: 'flex',
    alignItems: 'center',

    '& > div': {
      flexShrink: 1,
    },

    '& .custom-split-menu-group-icon': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '20px',
      ...shorthands.margin('0', '0', '0', 'auto'),

      '&::before': {
        content: '""',
        width: '1px',
        height: '20px',
        backgroundColor: tokens.colorNeutralStroke1,
      },
    },
  },
  scopeMenuItem: {
    alignItems: 'start',
    height: 'auto',
    minHeight: '28px',

    '& .fui-MenuItem__content': {
      color: tokens.colorBrandForegroundLink,
      wordBreak: 'break-word',
    },
  },
  scopeSearch: {
    marginBottom: '4px',
    ...shorthands.padding(tokens.spacingVerticalNone, tokens.spacingHorizontalM),
    '& .fui-Input': {
      width: '100%',
    },
  },
  entityListGroup: {
    '& .fui-MenuItem': {
      paddingLeft: '16px',
    },
  },
  entityListHeader: {
    fontWeight: tokens.fontWeightRegular,
    ...truncatedText,
    '& button': {
      ...textButton,
    },
  },
});

const CommonStatusStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '10px',
  position: 'relative',
  paddingRight: '10px',
};

export const useStatusStyles = makeStyles({
  activeStatus: {
    ...CommonStatusStyle,
    color: tokens.colorPaletteGreenForeground1,
  },
  pausedStatus: {
    ...CommonStatusStyle,
    color: tokens.colorNeutralForeground3,
  },
});

export const useBreadcrumbStyles = makeStyles({
  root: {
    display: 'flex',
    ...shorthands.overflow('hidden'),
    fontWeight: tokens.fontWeightRegular,
    '& button': {
      ...textButton,
    },
  },
  chevron: {
    position: 'relative',
    top: '2px',
    ...shorthands.padding('0', '2px'),
  },
  firstBreadcrumb: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  breadcrumbItems: truncatedText,
});

export const useTrucatedTextStyles = makeStyles({
  truncatedTextContainer: {
    display: 'flex',
    ...shorthands.overflow('hidden'),
    '& .trucated-text': {
      ...truncatedText,
    },
  },

});

export const useScopeFilterMenuStyles = makeStyles({
  filterContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    minWidth: 0,
    flexGrow: 1,
    flexShrink: 0,
    ...shorthands.overflow('hidden'),
    justifyContent: 'flex-end',
  },
  menuButton: {
    fontWeight: tokens.fontWeightSemibold,
    flexGrow: 1,
    flexShrink: 0,
    paddingLeft: tokens.spacingHorizontalSNudge,
    paddingRight: tokens.spacingHorizontalSNudge,
    textAlign: 'left',

    '&>span': {
      height: 'auto',
      width: 'auto',
      display: 'flex',
      alignItems: 'center',
    },

    '& .filter-name': {
      fontWeight: tokens.fontWeightRegular,
    },

    '& .filter-button-text': {
      display: 'block',
      flexGrow: 1,
    },
  },
});

export const useScollingContainerStyles = makeStyles({
  root: {
    ...shorthands.overflow('hidden'),
    ...shorthands.padding('4px'),
    '&>div': {
      scrollbarGutter: 'stable',

      '&::-webkit-scrollbar': {
        backgroundColor: 'transparent',
        borderRadius: '4px',
        '-webkit-border-radius': '10px',
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
        borderRadius: '4px',
        '-webkit-border-radius': '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
        '-webkit-border-radius': '10px',
        backgroundColor: tokens.colorNeutralForeground3,
      },
      ':hover': {
        overflowY: 'auto',
      },
    },
  },

  scopeBar: {
    maxHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
  },

  scopePanel: {
    flexGrow: 0,
  },
});
